// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___1TrsU","main":"styles__main___3QfzI","desc":"styles__desc___268_r","title":"styles__title___3pzBV","logo":"styles__logo___3lkBU","groupName":"styles__groupName___2yLHW","groupDescription":"styles__groupDescription___rKOit","content":"styles__content___1BhRO","clearButton":"styles__clearButton___1nJfO","rotate":"styles__rotate___2Q0zA","fadein":"styles__fadein___2BvtW","slideFromRight":"styles__slideFromRight___3jrGB","waves":"styles__waves___1QZiS"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/About/styles.scss
// module id = ./resources/assets/js/containers/About/styles.scss
// module chunks = 0